import * as React from "react"
import {Message} from "semantic-ui-react"
import {mixed} from "./tsutil"

interface State {
  error: Error | null
}

interface Props {}

export const systemErrorMessage =
  "A system error has occurred. Please try again later or" + " contact us."

export function ErrorComponent(props: {error: mixed}) {
  return (
    <Message style={{display: "block"}} error>
      {systemErrorMessage}
    </Message>
  )
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {error: null}
  }

  componentDidCatch(error: Error) {
    console.error(error)
    this.setState({error})
  }

  render() {
    if (this.state.error) {
      return <ErrorComponent error={this.state.error} />
    } else {
      return this.props.children
    }
  }
}



// WEBPACK FOOTER //
// ./src/ErrorBoundary.tsx